import React from 'react';

import { Auth } from './types';
import { AuthContext } from '.';

export function useAuth(): Auth {
  return React.useContext(AuthContext);
}
